// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2v-q";
export var animationRelative = "_2v-p";
export var backdropBlur = "_2v-0";
export var detailLabelCell = "_2v-12";
export var detailTable = "_2v-11";
export var detailValueCell = "_2v-13";
export var docIconBox = "_2v-1d";
export var docIconBoxMd = "_2v-1f";
export var docIconBoxSm = "_2v-1e";
export var docTypeRow = "_2v-16";
export var docTypeRowInner = "_2v-17";
export var dropdownMatchDatePicker = "_2v-3";
export var evidenceCardContent = "_2v-1c";
export var fileUploadSpin = "_2v-j";
export var gorgiasOpenButton = "_2v-15 _2v-d";
export var gorgiasTicketCard = "_2v-14";
export var heroModalFooterButton = "_2v-18";
export var hiddenContainer = "_2v-o";
export var iconPrimary = "_2v-1g";
export var iconSecondary = "_2v-1h";
export var iconTertiary = "_2v-1i";
export var integrationCard = "_2v-1";
export var integrationLogoBox = "_2v-2";
export var mainColumnSticky = "_2v-1b";
export var maxWidthContainer = "_2v-19";
export var modalContentBody = "_2v-a";
export var modalHeaderImage = "_2v-5";
export var modalImageLabel = "_2v-7";
export var modalImageOverlay = "_2v-6";
export var modalImageSubtitle = "_2v-9";
export var modalImageTitle = "_2v-8";
export var modalImageWrapper = "_2v-4";
export var modalStickyFooter = "_2v-b";
export var removeButton = "_2v-e";
export var sidebarColumn = "_2v-1a";
export var spinner = "_2v-i";
export var timelineLine = "_2v-y";
export var timelineLineBlack = "_2v-10 _2v-y";
export var timelineLineGray = "_2v-z _2v-y";
export var timelineLineHeight = "_2v-x";
export var tlDotActivate = "_2v-u";
export var tlDotActivateAnim = "_2v-t";
export var tlDotHide = "_2v-s";
export var tlDotHideAnim = "_2v-r";
export var tlLineActivate = "_2v-w";
export var tlLineActivateAnim = "_2v-v";
export var uploadHint = "_2v-n";
export var uploadIconBox = "_2v-k";
export var uploadLabel = "_2v-m";
export var uploadText = "_2v-l";
export var uploadZone = "_2v-f";
export var uploadZoneCursorDefault = "_2v-h";
export var uploadZoneCursorPointer = "_2v-g";
export var uploadedFileRow = "_2v-c";
export var viewButton = "_2v-d";